"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortDetectionsByStreemshotId = exports.groupDetectionsByStreemshotId = exports.findStreemshotRevision = exports.dedupeDetections = void 0;
const streem_sdk_protobuf_1 = require("streem-sdk-protobuf");
const dedupeDetections = (detections) => {
    return detections.reduce((acc, detection) => {
        if (!acc.some(x => x.description === detection.description && x.type === detection.type)) {
            acc.push(detection);
        }
        return acc;
    }, []);
};
exports.dedupeDetections = dedupeDetections;
// When a streemshot is edited, a revision is created with a new id.  The revision's streemshotId
//   is equal to the original streemshot's id.  (The original's streemshotId prop is undefined.)
//
//   Detections are associated with the original's id, but the streemshot page displays
//   the latest revision (if one exists).
//
//      1. To find the matching detections for a revision, find the detections with streemshotSid
//           equal to the revision's streemshotId.
//      2. To find the matching detections for an original, find the detections with streemshotSid
//           equal to the original's id.
//
//   Note that the streemshots array will not contain both the original and the revision.  It will
//      only contain the latest revision if one exists or, when none exists, the original.
//
//   See: https://github.com/streem/streem-app/pull/11949/files#r1003891375
const findStreemshotRevision = (streemshots, detectionStreemshotSid) => {
    const streemshotToDisplay = streemshots.find(ss => {
        return ss.id === detectionStreemshotSid || ss.streemshotId === detectionStreemshotSid;
    });
    return streemshotToDisplay;
};
exports.findStreemshotRevision = findStreemshotRevision;
const groupDetectionsByStreemshotId = (detections, streemshots) => {
    return detections.reduce((acc, detection) => {
        var _a;
        let entry = acc.find(x => x.streemshotId === detection.streemshotSid);
        if (!entry) {
            const streemshotToDisplay = (0, exports.findStreemshotRevision)(streemshots, detection.streemshotSid);
            entry = {
                streemshotId: detection.streemshotSid,
                streemshotCreatedAtSeconds: ((_a = detection.streemshotCreatedAt) === null || _a === void 0 ? void 0 : _a.seconds) || 0,
                modelNumbers: [],
                serialNumbers: [],
                streemshotRevisionId: (streemshotToDisplay === null || streemshotToDisplay === void 0 ? void 0 : streemshotToDisplay.id) || detection.streemshotSid,
            };
            acc.push(entry);
        }
        if (detection.type === streem_sdk_protobuf_1.streem.api.Detection.Type.DETECTION_TYPE_MODEL) {
            entry.modelNumbers.push(detection);
        }
        else if (detection.type === streem_sdk_protobuf_1.streem.api.Detection.Type.DETECTION_TYPE_SERIAL) {
            entry.serialNumbers.push(detection);
        }
        else {
            throw new Error(`Unexpected detection type: ${detection.type}`);
        }
        return acc;
    }, []);
};
exports.groupDetectionsByStreemshotId = groupDetectionsByStreemshotId;
const sortDetectionsByStreemshotId = (detections) => {
    return detections.sort((a, b) => {
        return a.streemshotCreatedAtSeconds - b.streemshotCreatedAtSeconds;
    });
};
exports.sortDetectionsByStreemshotId = sortDetectionsByStreemshotId;
//# sourceMappingURL=detection_helpers.js.map